import React, { Component } from "react";
import { connect } from "react-redux";
import { getMappings } from "pages/getPageTemplatesMappings";
import { PageComponent } from "components/page";

class Logout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mappings: {},
    };
  }

  componentDidMount() {
    getMappings("logout", this.props.match.params.tenantId)
      .then((mappings) => this.setState({ mappings: mappings }))
      .catch((error) => console.log(error));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language !== this.props.language) {
      getMappings("logout", this.props.match.params.tenantId)
        .then((mappings) => this.setState({ mappings: mappings }))
        .catch((error) => console.log(error));
    }
  }

  render() {
    return (
      <div className="loginDigiDForm panel">
        <PageComponent content={this.state.mappings["E_DELIVERY_LOGOUT_PAGE"]}/>
      </div>
    );
  }
}

//export default Logout
const mapStateToProps = (state) => state.i18n;
export default connect(mapStateToProps)(Logout);
